/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/elements/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponsePolygonAnnotation = dynamic(
  () => import('../tasks/TaskResponseImagePolygonAnnotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

export const realResponse = {
  annotations: [
    {
      key: '486aebc6-2476-4343-b0b2-c0bad86d776c',
      vertices: [
        {
          x: 184,
          y: 345
        },
        {
          x: 213,
          y: 302
        },
        {
          x: 348,
          y: 272
        },
        {
          x: 367,
          y: 248
        },
        {
          x: 456,
          y: 227
        },
        {
          x: 531,
          y: 243
        },
        {
          x: 604,
          y: 227
        },
        {
          x: 638,
          y: 243
        },
        {
          x: 700,
          y: 352
        },
        {
          x: 697,
          y: 394
        },
        {
          x: 643,
          y: 409
        },
        {
          x: 590,
          y: 373
        },
        {
          x: 469,
          y: 400
        },
        {
          x: 453,
          y: 427
        },
        {
          x: 296,
          y: 466
        },
        {
          x: 234,
          y: 444
        }
      ],
      label: 'pool'
    }
  ]
};

export const instruction = 'Draw a tight polygon around every pool in the image.';

const responseCode = `{
  "annotations": [
    {
      "vertices": [
        {
          "x": 184,
          "y": 345
        },
        {
          "x": 213,
          "y": 302
        },
        {
          "x": 348,
          "y": 272
        },
        {
          "x": 367,
          "y": 248
        },
        {
          "x": 456,
          "y": 227
        },
        {
          "x": 531,
          "y": 243
        },
        {
          "x": 604,
          "y": 227
        },
        {
          "x": 638,
          "y": 243
        },
        {
          "x": 700,
          "y": 352
        },
        {
          "x": 697,
          "y": 394
        },
        {
          "x": 643,
          "y": 409
        },
        {
          "x": 590,
          "y": 373
        },
        {
          "x": 469,
          "y": 400
        },
        {
          "x": 453,
          "y": 427
        },
        {
          "x": 296,
          "y": 466
        },
        {
          "x": 234,
          "y": 444
        }
      ],
      "label": "pool"
    }
  ]
}`;

export const code = `client.createPolygonannotationTask({
  instruction: '${instruction}',
  attachment: 'http://i.imgur.com/XOJbalC.jpg',
  objects_to_annotate: ['pool'],
  with_labels: true
}, (err, task) => {
    // do something with task
});`;

export const response = (
  <div>
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => (
  <TaskResponsePolygonAnnotation
    annotations={[]}
    imageURL="/static/img/examples/polygons-drones.png"
    rounded
  />
);

export const result = (
  <TaskResponsePolygonAnnotation
    annotations={realResponse.annotations}
    imageURL="/static/img/examples/polygons-drones.png"
    rounded
  />
);
